import React from 'react';

import ComponentHeader from '@totem/components/ComponentHeader';
import AnalysisReportContainer from '@totem/components/surveyV2/analysisReport/analysisReportContainer';
import AnalysisReportFilterPanel from '@totem/components/surveyV2/analysisReport/analysisReportFilterPanel';
import AuditPolicies from '@totem/components/surveyV2/analysisReport/auditPolicies/auditPolicies';
import Overview from '@totem/components/surveyV2/analysisReport/overview';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import PageSectionBody from '@totem/components/ui_components/page/PageSectionBody';

const AnalysisReportPage = () => {
  return (
    <ContentLayout>
      <AnalysisReportContainer>
        <IBCard isCovered title={'Analysis Report'}>
          <AnalysisReportFilterPanel />
          <ComponentHeader title={'Overview'} />
          <PageSectionBody>
            <Overview />
          </PageSectionBody>
          <ComponentHeader title={'Policies'} />
          <PageSectionBody>
            <AuditPolicies />
          </PageSectionBody>
        </IBCard>
      </AnalysisReportContainer>
    </ContentLayout>
  );
};

export default AnalysisReportPage;
